export const user = {
  globalUserId: null,
  memberId: null,
  session: null,
  openId: null,
};
